export function registrationErrorMessage(responseData: any): string {
    const errors = responseData?.errors;

    if (!errors || typeof errors !== "object") {
        return responseData?.error || "Registration failed. Please try again.";
    }

    const detail = errors.detail;
    if (typeof detail === "string") {
        return detail === "Internal Server Error"
            ? "Registration is temporarily unavailable. Please try again shortly."
            : detail;
    }

    const messages = Object.entries(errors).flatMap(([field, value]) => {
        const fieldMessages = Array.isArray(value) ? value : [value];

        return fieldMessages
            .filter((message): message is string => typeof message === "string")
            .map((message) => `${field.charAt(0).toUpperCase()}${field.slice(1)} ${message}.`);
    });

    return messages.join(" ") || "Registration failed. Please try again.";
}
